var __jsx = React.createElement;
import React from "react";
import { filter, isEmpty, get } from "lodash";
import { trackEvent } from "../../utils/mixpanel";
import { MIXPANEL_EVENTS } from "../../utils/mixpanelEvents";
import { isIOSWebView, truncateMiddle } from "../../utils";
import Store from "../../utils/Store";
import Button from "../common/Button";
import Toast from "../Toast";
import Modal from "../common/Modal";
import AwesomeIcon from "../AwesomeIcon";
import { faCircleExclamation } from "@fortawesome/pro-regular-svg-icons";
import { useTranslation } from "react-i18next";
import useMedia, { MediaSizes } from "../../hooks/useMedia";
import { useRouter } from "next/router";
var UploadCompleteModal = function UploadCompleteModal(props) {
  var selectedFiles = props.selectedFiles,
    onClose = props.onClose,
    onRetry = props.onRetry,
    hasCurrentPatient = props.hasCurrentPatient;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var filesList = Object.values(selectedFiles);
  var incompleteUploads = filter(filesList, {
    uploadComplete: false
  });
  var completeUploadCount = filesList.length - incompleteUploads.length;
  var isMobile = useMedia([MediaSizes.MOBILE], [true], false);
  var router = useRouter();
  var onClosePopup = function onClosePopup() {
    trackEvent(MIXPANEL_EVENTS.DICOM_UPLOAD_COMPLETE_CLOSED);
    onClose();
    if (!isMobile || hasCurrentPatient) {
      Store.update(function (s) {
        // eslint-disable-next-line no-param-reassign
        s.uploadModal = {
          isOpen: false,
          hasCurrentPatient: false
        };
      });
    } else if (isIOSWebView()) {
      router.back();
    } else {
      router.push("/patients");
    }
  };
  if (incompleteUploads.length <= 0) {
    Toast.success(t("toast.scans_uploaded_successfully"));
    onClosePopup();
    return null;
  }
  return /*#__PURE__*/React.createElement(Modal, {
    show: true,
    onClose: onClosePopup,
    title: t("imported_scans"),
    className: "sm:w-8/12 lg:w-6/12"
  }, /*#__PURE__*/React.createElement("div", {
    className: "px-6 py-3 my-3 h-56 overflow-y-auto"
  }, /*#__PURE__*/React.createElement("div", {
    className: "font-bold text-gray-900 dark:text-white text-left"
  }, completeUploadCount, "/", filesList.length, " ", t("files_imported_successfully"), ".", " ", !isEmpty(incompleteUploads) ? " ".concat(t("following_errors_occurred"), ":") : ""), /*#__PURE__*/React.createElement("table", {
    className: "min-w-full text-left rounded p-4"
  }, /*#__PURE__*/React.createElement("tbody", {
    className: "text-gray-900 dark:text-white"
  }, incompleteUploads.map(function (file) {
    var fileName = get(file, ["fileName"], "");
    var patientName = get(file, ["metaData", "PatientName"], "");
    var inValidMessage = get(file, ["inValidMessage"], "");
    var errorCode = get(file, ["errorCode"], 0);
    return /*#__PURE__*/React.createElement("tr", {
      key: fileName,
      className: "leading-8"
    }, /*#__PURE__*/React.createElement("td", {
      className: "w-1/4",
      title: fileName
    }, truncateMiddle(fileName, 20)), /*#__PURE__*/React.createElement("td", {
      className: "w-1/4",
      title: patientName
    }, truncateMiddle(patientName, 20)), /*#__PURE__*/React.createElement("td", {
      className: "w-1/4 text-md italic"
    }, /*#__PURE__*/React.createElement("div", {
      className: "flex items-center"
    }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(AwesomeIcon, {
      name: faCircleExclamation,
      className: "text-yellow-600 w-6 mr-1"
    })), /*#__PURE__*/React.createElement("div", {
      className: "leading-4"
    }, t(inValidMessage), errorCode ? " (".concat(errorCode, ")") : ""))));
  })))), /*#__PURE__*/React.createElement("div", {
    className: "flex items-center justify-end p-4 border-t border-gray-600"
  }, !isEmpty(incompleteUploads) && /*#__PURE__*/React.createElement(Button, {
    className: "px-6 py-4 grow-1 ml-4",
    onClick: function onClick() {
      trackEvent(MIXPANEL_EVENTS.DICOM_UPLOAD_RETRY);
      onRetry();
    }
  }, t("button.retry")), /*#__PURE__*/React.createElement(Button, {
    isPrimary: true,
    className: "px-6 py-4 grow-1 ml-4",
    onClick: function onClick() {
      onClosePopup();
    }
  }, t("button.close_proceed"))));
};
export default UploadCompleteModal;